export class NyukyoshaInformationViewModel {
    constructor(model) {
        this.model = model;
    }
    model;
    get informationNo() {
        return this.model.informationNo;
    }
    get weight() {
        return this.model.weight;
    }
    get responseContent() {
        return this.model.responseContent;
    }
    get startAt() {
        return this.model.startAt;
    }
    get endAt() {
        return this.model.endAt;
    }
    get subject() {
        return this.model.subject;
    }
    get isReaded() {
        return this.model.isReaded;
    }
}
